import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TKCompareStore from './tk.compare.store';
import { useStore, waitForStore } from '@tk/utilities/tk.use.store';

export default class TKCompareInfo extends TKCustomElementFactory {
    store?: TKCompareStore;
    anchor?: HTMLAnchorElement;
    emptyClassName: string;
    protected unsubscribe?: () => void;

    constructor() {
        super();

        this.anchor = this.querySelector('a') || undefined;
        this.emptyClassName = this.getDataAttribute('empty-class-name', 'tk-button__header--empty');
    }

    async connectedCallback(): Promise<void> {
        if (!this.anchor) throw new Error('Compare Info: Element is missing!');
        await waitForStore('compareStore');
        this.store = useStore('compareStore') as TKCompareStore;
        this.unsubscribe = this.store.subscribe(() => this.render());
        this.render();
    }

    disconnectedCallback(): void {
        this.unsubscribe && this.unsubscribe();
    }

    render() {
        if (!this.store) return;
        const { categories } = this.store.getState();
        this.anchor?.classList.toggle(this.emptyClassName, categories.length === 0);
        this.anchor?.setAttribute('data-count', String(categories.length));
    }
}
